<template>
  <li class="context__menu-item">
    <a class="context__menu-item-link" @click.stop="siguiente()">
      <i class="context__menu-item-icon" :class="icono"></i>
      Tema: {{ etiqueta }}
    </a>
  </li>
</template>

<script>
import { leerModo, leerPiel, guardar, resolver, MODOS } from '@extras_mg/tema'

/**
 * Interruptor de tema en el menu de usuario de la barra lateral.
 *
 * Se cuelga de getUserContextComponents(), que es un punto de extension del
 * core (MIT) y espera un <li> con la pinta de los demas del menu.
 *
 * Cicla entre los tres modos con un clic en vez de abrir un submenu: son tres
 * opciones y el menu ya esta abierto encima. El @click lleva .stop para que el
 * Context no se cierre al cambiar, y se pueda ver el cambio sin reabrirlo.
 */
export default {
  name: 'SelectorDeTema',
  data() {
    return { modo: 'sistema' }
  },
  computed: {
    etiqueta() {
      return { sistema: 'automatico', claro: 'claro', oscuro: 'oscuro' }[
        this.modo
      ]
    },
    icono() {
      if (this.modo === 'claro') return 'iconoir-sun-light'
      if (this.modo === 'oscuro') return 'iconoir-half-moon'
      return 'iconoir-computer'
    },
  },
  mounted() {
    // Se lee en mounted y no en data(): data() tambien corre en el servidor,
    // donde no hay localStorage ni window.
    this.modo = leerModo()
    this.escuchar()
  },
  beforeUnmount() {
    if (this.consulta) {
      this.consulta.removeEventListener('change', this.alCambiarElSistema)
    }
  },
  methods: {
    siguiente() {
      this.modo = MODOS[(MODOS.indexOf(this.modo) + 1) % MODOS.length]
      guardar(this.modo)
      // Con la piel de Monday puesta el tema no se nota: esa piel es clara.
      // Se avisa en vez de cambiar la piel por cuenta propia.
      if (this.modo === 'oscuro' && leerPiel() === 'monday') {
        this.$store.dispatch('toast/info', {
          title: 'El tema oscuro necesita apagar el aspecto Monday',
          message:
            'El aspecto Monday es claro. Cambia "Aspecto" a Clásico en este mismo menú para ver el tema oscuro.',
        })
      }
    },
    escuchar() {
      // Con el modo en "automatico", si el usuario cambia el tema de su sistema
      // operativo con Baserow abierto, la pagina tiene que seguirlo.
      try {
        this.consulta = window.matchMedia('(prefers-color-scheme: dark)')
        this.consulta.addEventListener('change', this.alCambiarElSistema)
      } catch (e) {
        this.consulta = null
      }
    },
    alCambiarElSistema() {
      if (this.modo === 'sistema') {
        document.documentElement.setAttribute('data-tema', resolver('sistema'))
      }
    },
  },
}
</script>
